export default __webpack_public_path__ + "static/media/flag-yemen.338a95fc.svg";